// extracted by mini-css-extract-plugin
export default {"container":"skills_container__oJfOI","title":"skills_title__h9uXU","group":"skills_group__nI5SO"};